import React, {useContext, useEffect, useState} from 'react'
import {withTranslation, Trans} from 'react-i18next'
import { map as lMap, sortBy as lSort } from 'lodash'
import ResultRow from '../../../../molecules/ResultRow'
import {AuthContext} from '../../../../../app'
import Cookies from 'js-cookie'

import {
  apiGetAsoko2PickingGeneralResults,
  apiGetAllCompanies,
  apiGetCompanyFromId,
  apiGetWarehouseFromCompanyId,
  apiGetWarehouseAssignFromUserId,
} from '../../../../../utils/api'
import { checkSessionTimeout } from '../../../../../utils'

import ServiceButtonsSet from '../../../../molecules/ServiceButtonsSet'
import BasicInfoPanel from '../../../../organisms/BasicInfoPanel'

const PickingGeneralResHis = ({ t, setExecStatus }) => {
  const { userDetails } = useContext(AuthContext)
  const { company_id, role, id } = userDetails

  const [resultList, setResultList] = useState(null)
  const [companiesList, setCompaniesList] = useState([])
  const [selectedCompanyNo, setSelectedCompanyNo] = useState(0)
  const [warehousesList, setWarehousesList] = useState([])
  const [selectedWarehouseNo, setSelectedWarehouseNo] = useState(0)
  const [initFlg, setInitFlg] = useState(false)
  const [ isChangeFlag, setIsChangeFlag ] = useState(false)

  // ページング機能  
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const pageSize = 100

  const fetchResultList = (page = 1) => {
    const exec_status = Cookies.get('exec_status')
    const kind = Cookies.get('kind')
    if(kind === 'g' && exec_status === 'done') {
      Cookies.set('exec_status', '')
      Cookies.set('kind', '')
      setExecStatus('done')
    }

    const cookies_warehouseId = Cookies.get('warehouse_id')
    // console.log('---cookies_warehouseId --> ' + cookies_warehouseId)

    async function fetchData() {
      const {
        data: { data: res },
      } = await apiGetAsoko2PickingGeneralResults(cookies_warehouseId, page, pageSize)
      setResultList(res.results)
      setCurrentPage(res.page)
      setTotalPages(res.totalPages)
      setTotalCount(res.totalCount)
    }
    fetchData()
    setIsChangeFlag(false)
  }

  useEffect(() => {
    isChangeFlag && fetchResultList(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChangeFlag])

  const fetchPanelData = async () => {
    const companyIdFromCookie =
      (role === 'admin' && Cookies.get('company_id'))
        ? Cookies.get('company_id')
        : company_id

    const {
      data: { data: details_c },
    } = (role === 'admin')
      ? await apiGetAllCompanies()
      : await apiGetCompanyFromId(companyIdFromCookie)

    const indexOfCompanyNo = details_c.indexOf(
      details_c.find(details => details['id'] === companyIdFromCookie)
    )
    const companyNoFromCookie = !!indexOfCompanyNo
      ? indexOfCompanyNo
      : (role === 'admin' && Cookies.get('company_no'))
        ? Number(Cookies.get('company_no'))
        : 0

    setCompaniesList(details_c)
    setSelectedCompanyNo(companyNoFromCookie)

    const warehouseNoFromCookie =
      Cookies.get('warehouse_no')
        ? Number(Cookies.get('warehouse_no'))
        : 0

    const {
      data: { data: details_w },
    } = await apiGetWarehouseFromCompanyId(companyIdFromCookie)

    const {
      data: { data: details_assigned },
    } = await apiGetWarehouseAssignFromUserId(id)

    const filteredDetails_w =
      (role === 'admin')
        ? details_w
        : details_w.filter(
            warehouse => details_assigned.find(
              assigned => assigned['warehouse_id'] === warehouse['id']
            )
          )

    setWarehousesList(filteredDetails_w)
    setSelectedWarehouseNo(warehouseNoFromCookie)

    Cookies.set('company_no', companyNoFromCookie)
    Cookies.set('company_id', details_c[companyNoFromCookie]['id'])
    Cookies.set('warehouse_no', warehouseNoFromCookie)
    Cookies.set('warehouse_id', filteredDetails_w[warehouseNoFromCookie]['id'])
    setInitFlg(true)
  }

  const initData = async () => {
    await fetchPanelData()
    await fetchResultList(1)
  }

  useEffect(() => {
    const loginTime = Cookies.get('login_time')
    checkSessionTimeout(loginTime)

    initData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const props = {
    i18nKey: 'picking_general_reshis',
    handleSelectId: setIsChangeFlag,
    companiesList: companiesList,
    selectedCompanyNo: selectedCompanyNo,
    setSelectedCompanyNo: setSelectedCompanyNo,
    warehousesList: warehousesList,
    setWarehousesList: setWarehousesList,
    selectedWarehouseNo: selectedWarehouseNo,
    setSelectedWarehouseNo: setSelectedWarehouseNo,
    fetchPanelData: fetchPanelData,
    initFlg: initFlg,
  }

  return (
    <div className='padding2'>
      <BasicInfoPanel props={props} />
      <div>
        <br/>
        <table className='asoko2-table' cellSpacing={0}>
          <thead>
            <tr>
            <th><Trans t={t} i18nKey='executed' /></th>
              <th><Trans t={t} i18nKey='executed_user' /></th>
              <th><Trans t={t} i18nKey='exec_filename' /></th>
              <th><Trans t={t} i18nKey='result' /></th>
              <th><Trans t={t} i18nKey='opt_picking_list' /></th>
              <th><Trans t={t} i18nKey='workload_list' /></th>
              <th><Trans t={t} i18nKey='execution_log' /></th>
            </tr>
          </thead>
          <tbody>
            {lMap(resultList, (u, index) => (
              <ResultRow
                key={index}
                u={u}
              />
            ))}
          </tbody>
        </table>
        <div
          style={{
            marginTop: '15px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px'
          }}
        >
          {currentPage > 1 && (
            <button
              className="home-menu-back-btn"
              onClick={() => fetchResultList(currentPage - 1)}
            >
              ◀前へ
            </button>
          )}

          <span>
            {currentPage} / {totalPages}
            （全 {totalCount} 件）
          </span>

          {currentPage < totalPages && (
            <button
              className="home-menu-back-btn"
              onClick={() => fetchResultList(currentPage + 1)}
            >
              次へ▶
            </button>
          )}
        </div>
      </div>
      <ServiceButtonsSet backTo='/pickinggeneralmenu' />
    </div>
  )
}

export default withTranslation()(PickingGeneralResHis)
